export enum DeliveryLocation {
  MARTORELL = 'FABR MARTORELL'
}
